// Library Imports
import React, { Component } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import { connect } from "react-redux";
import { MdDelete, MdModeEdit, MdOutlineQuestionAnswer } from "react-icons/md";
import { FaListAlt } from "react-icons/fa";
import { BsFillEyeFill } from "react-icons/bs";
import { RiArrowGoBackLine } from "react-icons/ri";
import { Pagination } from "@material-ui/lab";
import { CircularProgress } from "@material-ui/core";
import SweetAlert from "react-bootstrap-sweetalert";
import { Button } from "react-bootstrap";
import Tooltip from "react-tooltip";

// Components Imports
import { Redirect, Link } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import DefaultButton from "../ReusableComponents/DefaultButton";
import ModalQuestao from "./ModalQuestao";
import TextReadMore from "../ReusableComponents/TextReadMore";

// Utils Imports
import { logout } from "../../actions/AppActions";
import { get, del } from "../../Services/api";
import { PreferencesContext } from '../../contexts/PreferencesContext';
import StatusBadge, { getApprovalStatus } from "../ReusableComponents/StatusBadge";
import WorkQueueItem from '../ReusableComponents/WorkQueueItem';

class Questoes extends Component {
  static contextType = PreferencesContext;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: "/",
      loading_screen: false,
      questoes: [],
      pagination: {
        page: 1,
        last_page: 1,
      },
      categoria: { name: "" },
      demanda: { name: "" },
      demanda_professor: {},
      msgErro: "",
      show_warning: false,
      show_erro: false,
      unidade_to_delete: "",
      search: "",
      loading_search: true,
      showModal: false,
      questaoSelect: null,
    };
  }

  componentDidMount() {
    this.get_questoes(this.state.page);
  }

  get_questoes(page, search = "", busca = true) {
    const { demanda_id } = this.props.match.params;
    const { token, logout } = this.props;

    if (busca) {
      if (!this.state.loading_search) {
        this.setState({ loading_search: true });
      }
    } else if (!this.state.loading_screen) {
      this.setState({ loading_screen: true });
    }

    get(
      `api/professor/get_questoes_demanda/${demanda_id}?page=${page}&search=${search}&questoes=true`,
      token
    )
      .then((resp) => {
        if (!resp) {
          logout();
          return;
        }

        this.setState({
          loading_search: false,
          categoria: resp.categoria,
          demanda: resp.demanda,
          demanda_professor: resp.demanda_professor,
          questoes: resp.questoes,
          loading_screen: false,
          pagination: resp.pagination,
        });
      })
      .catch((err) => {
        this.setState({ redirect: true });
        console.error(err);
      });
  }

  delete_questao(id) {
    const { token, logout } = this.props;

    del(`api/professor/delete_questao/${id}`, token)
      .then((resp) => {
        if (!resp) {
          logout();
          return;
        }

        this.setState({ show_warning: false });
        this.get_questoes(this.state.page, this.state.search);
      })
      .catch((err) => {
        this.setState({ redirect: true });
        console.error(err);

        this.setState({
          msgErro: err.message,
          show_warning: false,
          show_erro: true,
        });
      });
  }

  render() {
    return (
      <div className="row">
        {this.state.redirect == true && <Redirect to={this.state.path} />}
        <ModalQuestao
          showModal={this.state.showModal}
          setShowModal={(e) => this.setState({ showModal: e })}
          questao={this.state.questaoSelect}
        />

        <div className="col-12">
          <div className="card">
            <div className="card-body" id="card">
              <div style={{ float: "right" }}>
                <DefaultButton
                  bg="secondary"
                  text={this.context.t('action_back')}
                  icon={<RiArrowGoBackLine />}
                  to={`/demandas/show/${this.state.demanda.id}`}
                />
              </div>
              <h4
                className="mt-0 header-title"
                style={{ fontSize: "1.5rem" }}
              >
                {this.context.t('title_question_list')}
              </h4>
              <p style={{ fontSize: "1rem" }}>{this.context.t('authorQuestionsDescription')}</p>
              <p style={{ fontSize: "1rem", color: "black", marginBottom: 5 }}>
                <b>{this.context.t('label_objective_question_count')}:</b>{" "}
                {this.state.demanda_professor.questoes}
                {this.state.demanda_professor.numero_questoes == null
                  ? ""
                  : "/" + this.state.demanda_professor.numero_questoes}
              </p>
              <p style={{ fontSize: "1rem", color: "black", marginBottom: 5 }}>
                <b>{this.context.t('label_essay_question_count')}:</b>{" "}
                {this.state.demanda_professor.questoes_dissertativas}
                {this.state.demanda_professor.numero_questoes_dissertativas ==
                null
                  ? ""
                  : "/" +
                    this.state.demanda_professor.numero_questoes_dissertativas}
              </p>

              {this.state.demanda_professor.id != null && (
                <TextReadMore
                  title={`${this.context.t('label_descriptive')}: `}
                  element="div"
                  limit={1000}
                  style={{ width: "100%", marginBottom: 10, whiteSpace: "pre" }}
                >
                  {this.state.demanda_professor?.descritivo}
                </TextReadMore>
              )}
              <br />
              <br />

              <div className="row">
                <div className="col-12">
                  {/* <hr /> */}
                  {this.state.loading_screen == false && (
                    <div>
                      {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                      {/* <br /> */}

                      <div className="questions-list-toolbar mb-4">
                        <div className="questions-search-shell">
                        <Search hide_class className="questions-search"
                          placeholder={this.context.t('placeholder_search_question')}
                          ValueChange={(value) => {
                            clearTimeout(this.pesquisarTimeout);
                            this.pesquisarTimeout = setTimeout(() => {
                              let page = { ...this.state.pagination };
                              page.current_page = 1;
                              this.setState({
                                pagination: page,
                                search: value,
                                loading_search: true,
                              });
                              this.get_questoes(1, value);
                            }, 500);
                          }}
                        />
                        </div>

                        <div className="questions-actions">
                        {(this.state.demanda_professor
                          .numero_questoes_dissertativas == null ||
                          this.state.demanda_professor.numero_questoes ==
                            null ||
                          this.state.demanda_professor.questoes +
                            this.state.demanda_professor
                              .questoes_dissertativas <
                            this.state.demanda_professor.numero_questoes +
                              this.state.demanda_professor
                                .numero_questoes_dissertativas) && (
                          <Link
                            to={{
                              pathname:
                                "/atribuicao/questoes/register/" +
                                this.props.match.params.demanda_id,
                              // state: {
                              //     course_id: id
                              // }
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              variant="success"
                              className="flex align-center jcc"
                            >
                              <FaListAlt style={{ marginRight: 10 }} />{" "}
                              <p style={{ margin: 0 }}>{this.context.t('action_add_question')}</p>
                            </Button>
                          </Link>
                        )}
                        </div>
                      </div>

                      <div className="work-queue work-queue-questions">
                        {this.state.loading_search == false && this.state.questoes.map((item) => {
                          const questionType = item.type_questao == "conjunto"
                            ? `${this.context.t('question_group_prefix')} - ${item.questoes.length} ${this.context.t(item.questoes.length == 1 ? 'question_singular' : 'question_plural')}`
                            : item.type_questao == "simples"
                              ? this.context.t('question_multiple_choice')
                              : this.context.t('question_discursive');

                          return (
                            <WorkQueueItem
                              key={item.id}
                              icon={<MdOutlineQuestionAnswer />}
                              eyebrow={questionType}
                              title={item.text_questao}
                              meta={[
                                {
                                  label: this.context.t('label_correct_alternative'),
                                  value: item.type_questao == 'simples' ? `${item.correta})` : '-',
                                },
                              ]}
                              status={<StatusBadge {...getApprovalStatus(item.statusAprovacao)} />}
                              actions={(
                                <>
                                  <button
                                    type="button"
                                    className="work-queue-action-button secondary"
                                    onClick={() => this.setState({ questaoSelect: { ...item }, showModal: true })}
                                  >
                                    <BsFillEyeFill />
                                    <span>{this.context.t('action_manage_question')}</span>
                                  </button>
                                  {item.andamento == false && (
                                    <Link className="work-queue-action-button" to={`/atribuicao/questoes/edit/${item.id}`}>
                                      <MdModeEdit />
                                      <span>{this.context.t('action_edit_question')}</span>
                                    </Link>
                                  )}
                                </>
                              )}
                            />
                          );
                        })}
                      </div>
                      {this.state.loading_search == true && (
                        <div className="row" style={{ margin: 0 }}>
                          {" "}
                          <div className="col-12 d-flex justify-content-center align-items-center">
                            <CircularProgress />
                          </div>
                        </div>
                      )}
                      {this.state.loading_search == false &&
                        this.state.questoes.length == 0 && (
                          <div className="row w-100">
                            <div className="col-12">
                              <TableEmptyState title={this.context.t('empty_no_questions_found_dot')} icon="❓" />
                            </div>
                          </div>
                        )}

                      <Pagination
                        className={
                          this.state.pagination.last_page == 1 ? "hide" : ""
                        }
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={this.state.pagination.last_page}
                        value={this.state.pagination.current_page}
                        onChange={(_, value) => {
                          console.log(_, value);
                          let page = { ...this.state.pagination };
                          page.current_page = value;
                          this.setState({ pagination: page });
                          this.get_questoes(value, this.state.search);
                        }}
                      />

                      {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}
                    </div>
                  )}

                  {this.state.loading_screen == true && (
                    <div className="row">
                      {" "}
                      <div
                        className="col-12 d-flex justify-content-center align-items-center"
                        style={{ marginTop: "2rem" }}
                      >
                        {/* <div className="spinner-border text-primary" role="status"  >
        </div> */}
                        <CircularProgress />
                      </div>
                    </div>
                  )}

                  <SweetAlert
                    warning
                    title={this.context.t('legacy_atencao')}
                    onConfirm={() => {
                      this.setState({
                        show_warning: false,
                        loading_search: true,
                      });
                      this.delete_questao(this.questao_id);
                      // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                      this.setState({ show_warning: false });
                    }}
                    show={this.state.show_warning}
                    confirmBtnText={this.context.t('legacy_sim_desejo_apagar')}
                    cancelBtnText={this.context.t('action_cancel')}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                  >
                    {this.context.t('confirm_delete_question')}
                  </SweetAlert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapsStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token,
});

export default connect(mapsStateToProps, { logout })(Questoes);
